import React, { Component } from "react";
import Lottie from 'react-lottie';

import Animation from "./animation/Gif_004.json"
import "./style.scss";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Animation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

export class RunGelBox extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  doneClicked =()=>{
    this.props.showModal({
      display: false
    })
    this.props.runGel(true)
  }

  render() {

    return (
      <div className="modal-section run-gelbox" style={{ width: "calc(100% - 0px)", height: "650px", margin: "auto" }}>
        <div className="modal-header">
          <h2>Run Gel Electrophoresis Box</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner">
            <Lottie
              options={defaultOptions}
              width={"auto"}
              height={"100%"}
              isStopped={this.state.isStopped}
              isPaused={this.state.isPaused} />
          </div>
        </div>

        <div className="modal-footer">

          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={this.doneClicked}>
              Done
          </button>

        </div>

      </div>

    );
  }
}
